
<template>
  <naj-modal
    ref="billInvoiceModal"
    :title="local.judicialFees.billInvoice"
    button-size="small"
    :button-outlined="false"
    :width="1200"
    :persistent="true"
    :close-button="true"
    show-footer-close-button
    @onClose="$emit('billInvoiceModalClose');onClose();"
  >
    <template>
      <div>
        <v-row class="d-flex justify-center">
          <div class="attribute-item-row">
            <div class="attribute-item pa-3">
              <div class="text-title">
                {{ local.judicialFees.generalDetails }}
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <div class="attribute-item-row">
            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.providerName }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billDetails.providerName }}
              </div>
            </div>
            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.identityNumber }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billDetails.identityNumber }}
              </div>
            </div>
            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.customerName }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billDetails.customerName }}
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <div class="attribute-item-row">
            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.billedNo }}
              </div>
              <div class="attribute-item-value mt-3">
                342
              </div>
            </div>

            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.billNumber }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billDetails.invoiceNo }}
              </div>
            </div>

            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.amount }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billDetails.amount }} {{ local.judicialFees.sar }}
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <div class="attribute-item-row">
            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.creationDate }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ toHijriDate( billDetails.creationDate) }}
              </div>
            </div>
            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.expiryDate }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ toHijriDate( billDetails.expiryDate) }}
              </div>
            </div>

            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.statusName }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billDetails.statusName }}
              </div>
            </div>
          </div>
        </v-row>
      </div>
      <div v-if="billUpdateDetails">
        <v-row class="d-flex justify-center">
          <div class="attribute-item-row">
            <div class="attribute-item pa-3">
              <div
                v-if="billUpdateDetails.actionTypeId == 17"
                class="text-title"
              >
                {{ local.judicialFees.billRefundDetails.title }}
              </div>
              <div
                v-else
                class="text-title"
              >
                {{ local.judicialFees.billUpdateDetails.title }}
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <div class="attribute-item-row">
            <div class="attribute-item pa-3">
              <div class="attribute-item-title">
                {{ local.judicialFees.billRefundDetails.totalAmount }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billUpdateDetails.legacyBillAmount }} <span v-if="billUpdateDetails.legacyBillAmount">{{ local.judicialFees.sar }}</span>
              </div>
            </div>
            <div class="attribute-item pa-3">
              <div
                v-if="billUpdateDetails.actionTypeId == 17"
                class="attribute-item-title"
              >
                {{ local.judicialFees.billRefundDetails.amount }}
              </div>
              <div
                v-else
                class="attribute-item-title"
              >
                {{ local.judicialFees.billUpdateDetails.currentAmount }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billUpdateDetails.amount }} <span v-if="billUpdateDetails.amount">{{ local.judicialFees.sar }}</span>
              </div>
            </div>
            <div class="attribute-item pa-3">
              <div
                v-if="billUpdateDetails.actionTypeId == 17"
                class="attribute-item-title"
              >
                {{ local.judicialFees.billRefundDetails.refundedDate }}
              </div>
              <div
                v-else
                class="attribute-item-title"
              >
                {{ local.judicialFees.billUpdateDetails.updateDate }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ toHijriDate( billUpdateDetails.updatedDate) }}
              </div>
            </div>
            <div
              v-if="billUpdateDetails.actionTypeId == 17"
              class="attribute-item pa-3"
            >
              <div class="attribute-item-title">
                {{ local.judicialFees.billRefundDetails.refundedAmount }}
              </div>
              <div class="attribute-item-value mt-3">
                {{ billUpdateDetails.refundedAmount }} <span v-if="billUpdateDetails.refundedAmount">{{ local.judicialFees.sar }}</span>
              </div>
            </div>
          </div>
        </v-row>
      </div>
      <v-row>
        <div class="attribute-item-row">
          <div class="attribute-item pa-3">
            <div class="text-title">
              {{ local.judicialFees.summaryRequests }}
            </div>
          </div>
        </div>
      </v-row>
      <hr>
      <naj-data-table
        ref="selection"
        :headers="headers"
        :items="billItemDetails"
        :disable-items-per-page="true"
        :show-collapsing="false"
        :no-header="true"
      >
      </naj-data-table>
      <hr>

      <div class="text-title d-flex justify-content-between px-5 py-2">
        <div>
          {{ local.judicialFees.totalAmount }}
        </div>
        <div>
          {{ billDetails.amount }} {{ local.judicialFees.sar }}
        </div>
      </div>
    </template>
    <template slot="actions">
      <naj-button
        :loading="loading"
        @click="downloadInvoice()"
      >
        {{ local.judicialFees.print }}
      </naj-button>
    </template>

    <document-modal
      v-if="selectedAttachment!=null"
      ref="documentModalRef"
      :base64="selectedAttachment"
      :is-base64="true"
      @documentModalClose="selectedAttachment = null"
    ></document-modal>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapJudicialFeesActions } = createNamespacedHelpers('JudicialFeesModule');
import { toHijriDate } from '@/helpers/utils';
import DocumentModal from '../components/document-modal.vue';

export default {
  name: 'BillInvoiceModal',
  components: { DocumentModal },
  props: {
    billObjectKey: {
      default: null,
      type: String,
      required: false,
    },
    modalVisibility: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      billDetails: {},
      billItemDetails: [],
      billUpdateDetails: null,
      selectedAttachment: null,
      isBase64: false,
      headers: [
        {
          value: 'index',
          text: this.local.judicialFees.sequence,
        },
        {
          value: 'productName',
          text: this.local.judicialFees.productName,
        },
        {
          value: 'providerItemCode',
          text: this.local.judicialFees.providerItemCode,
        },
        {
          value: 'itemTypeName',
          text: this.local.judicialFees.itemTypeName,
        },
        {
          value: 'totalPrice',
          text: this.local.judicialFees.cost,

        },
      ],
    };
  },
  computed: {},
  watch: {
    modalVisibility(newVal) {
      newVal ? this.$refs.billInvoiceModal.show() : this.$refs.billInvoiceModal.close();
    },
    billObjectKey(newVal) {
      if (newVal) this.loadData();
    },
  },
  mounted() {
    if (this.billObjectKey) this.loadData();
  },
  methods: {
    toHijriDate,
    ...mapJudicialFeesActions([
      'getBillDetails',
      'getBillItemDetails',
      'getBillInvoiceReport',
      'getBillUpdateDetails',
    ]),
    loadData() {
      this.loading = true;
      Promise.all([
        this.getBillDetails(this.billObjectKey),
        this.getBillItemDetails(this.billObjectKey),
        this.getBillUpdateDetails(this.billObjectKey),
      ]).then((results) => {
        this.billDetails = results[0].data;
        this.billItemDetails = results[1].data;
        this.billUpdateDetails = results[2].data;
        this.billItemDetails.forEach((element, index) => {
          element.index = index + 1;
        });
      })
        .finally(() => {
          this.loading = false;
        });
    },
    onClose() {
      this.billDetails = [];
      this.billItemDetails = [];
      this.billUpdateDetails = [];
    },
    downloadInvoice() {
      this.loading = true;
      this.getBillInvoiceReport(this.billObjectKey)
        .then((res) => {
          this.selectedAttachment = res.data.content;
          this.isBase64 = true;
          this.$nextTick(() => {
            var modal = this.$refs.documentModalRef;
            modal.showModal();
          });

        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  color: var(--app-primary-color);
}

.text-title {
  font-size: 17px;
  font-weight: bold;
  color: var(--app-primary-color);
}

.card-boarder {
  border: 2px solid #dbdbdb;
}

.attribute-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

.attribute-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #080a0a;
}

.attribute-item-value {
  font-weight: bolder;
  font-size: 12px;
  color: var(--app-dark-primary-color);
  font-weight: bold;
}
.bill-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.bill-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

.bill-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #080a0a;
}

.bill-item-value {
  font-weight: bolder;
  font-size: 12px;
  color: var(--app-dark-primary-color);
}
</style>
